/* global stLight */

import 'shared/common'
import 'shared/make_model_menu'
import 'lite-youtube-embed'

function stCB () {
  stLight.options({
    publisher: '45bd57fd-a687-4bab-9195-35196f866c28',
    shorten: true,
    doNotHash: false,
    doNotCopy: false,
    hashAddressBar: false
  })
}

function initShareThis () {
  const stscr = document.createElement('script')
  stscr.type = 'text/javascript'
  stscr.async = true
  stscr.src = 'https://ws.sharethis.com/button/buttons.js'
  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(stscr, s)
  stscr.onload = stCB
  stscr.onreadystatechange = () => {
    if (stscr.readyState === 'loaded') {
      stCB()
    }
  }
}

initShareThis()
